import React from 'react';

const AccountSelectionModal = ({ list, platform, selectedIds, onSelect, onConfirm, onCancel, loading }) => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden animate-in fade-in zoom-in duration-200">
                <div className="p-6">
                    <div className="flex items-center justify-between mb-4">
                        <h3 className="text-xl font-bold text-gray-900">Select {platform} account</h3>
                        <span className="bg-red-100 text-red-600 text-xs font-bold px-2.5 py-1 rounded-full">
                            Found {list?.length || 0}
                        </span>
                    </div>

                    <p className="text-sm text-gray-500 mb-6">
                        Please select the pages or accounts you want to sync to Antares:
                    </p>

                    <div className="space-y-3 max-h-[320px] overflow-y-auto pr-2 custom-scrollbar">
                        {list?.map((acc) => {
                            const isSelected = selectedIds.includes(acc.platform_account_id);
                            return (
                                <div
                                    key={acc.platform_account_id}
                                    onClick={() => onSelect(acc.platform_account_id)}
                                    className={`group flex items-center p-4 border-2 rounded-xl cursor-pointer transition-all ${isSelected ? 'border-red-500 bg-red-50/50' : 'border-gray-100 hover:border-gray-200'
                                        }`}
                                >
                                    <div className="w-12 h-12 rounded-lg bg-gray-100 flex items-center justify-center text-gray-400 font-bold border border-gray-200">
                                        {acc.account_name.charAt(0)}
                                    </div>

                                    <div className="ml-4 flex-1">
                                        <p className="font-bold text-gray-900 leading-tight">
                                            {acc.account_name}
                                        </p>
                                        <div className="flex items-center mt-1">
                                            <span className="text-[10px] uppercase tracking-wider font-bold px-1.5 py-0.5 rounded bg-gray-100 text-gray-500 border border-gray-200">
                                                {acc.config?.category || 'General'}
                                            </span>
                                            <span className="ml-2 text-xs text-gray-400">
                                                Admin: {acc.config?.user_name}
                                            </span>
                                        </div>
                                    </div>

                                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all ${isSelected ? 'bg-red-600 border-red-600' : 'border-gray-300'
                                        }`}>
                                        {isSelected && (
                                            <svg className="w-3.5 h-3.5 text-white" fill="currentColor" viewBox="0 0 20 20">
                                                <path d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" />
                                            </svg>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="bg-gray-50 p-6 flex items-center justify-between gap-4">
                    <button
                        onClick={onCancel}
                        disabled={loading}
                        className="text-sm font-semibold text-gray-500 hover:text-gray-700 disabled:opacity-50"
                    >
                        Later
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={loading || selectedIds.length === 0}
                        className="flex-1 bg-red-600 disabled:bg-gray-300 text-white py-3 rounded-xl font-bold shadow-lg shadow-red-200 hover:bg-red-700 active:scale-[0.98] transition-all flex justify-center items-center"
                    >
                        {loading ? (
                            <div className="h-5 w-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                        ) : (
                            `Confirm${selectedIds.length > 0 ? ` (${selectedIds.length})` : ''}`
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AccountSelectionModal;